const ImageGeometryType = {
	EXTENT: "extent",
	QUAD: "quad"
};
export default ImageGeometryType;
